import {
  InputHTMLAttributes,
  ReactElement,
  RefObject,
  forwardRef,
} from 'react';
import { GoCheck, GoX } from 'react-icons/go';
import InputMask from 'react-input-mask';

import * as S from './styles';

interface Props extends InputHTMLAttributes<HTMLInputElement> {
  name: string;
  errorMessage?: string;
  mask?: string;
  label?: string;
  status?: 'default' | 'success' | 'error';
  Icon?: ReactElement;
  forwardRef?: RefObject<HTMLInputElement>;
  onClick?: () => void;
}

export const Input = forwardRef<HTMLInputElement, Props>(function Input(
  {
    name,
    errorMessage,
    mask,
    label,
    status = 'default',
    Icon,
    onClick,
    forwardRef,
    ...rest
  }: Props,
  ref
) {
  function StatusIcon() {
    switch (status) {
      case 'success':
        return <GoCheck />;
      case 'error':
        return <GoX />;
      default:
        return null;
    }
  }

  const { readOnly } = rest;

  const hasIcon = Icon || status !== 'default';

  return (
    <S.Wrapper>
      {label && <S.Label htmlFor={name}>{label}</S.Label>}

      <S.InputWrapper
        onClick={onClick}
        $variant={status}
        $readOnly={readOnly ?? false}
      >
        {!!mask ? (
          // @ts-ignore
          <InputMask
            name={name}
            id={name}
            mask={mask}
            maskChar={null}
            {...rest}
          />
        ) : (
          <input name={name} id={name} {...rest} ref={ref || forwardRef} />
        )}

        <S.MessageWrapper>
          <S.Error htmlFor={name}>{!!errorMessage && errorMessage}</S.Error>

          {hasIcon && <S.Icon>{Icon ? Icon : <StatusIcon />}</S.Icon>}
        </S.MessageWrapper>
      </S.InputWrapper>
    </S.Wrapper>
  );
});
